import React, { useState } from 'react';

import PurchaseTransactionsDialog from '.';
import useConfirmationDialogV2 from '../../../../../../commons/dialogV2/useConfirmationDialogV2';

function usePurchaseTransactionsDialog ({ usage } = {}) {
    const [open, setOpen] = useState(false);

    const { openDialog: openSuccessDialog, renderDialog: renderSuccessDialog } = useConfirmationDialogV2({
        showPrimaryButton: true,
        showSecondaryButton: false,
        confirmLabel: 'Ok',
    });

    function renderPurchaseTransactionsDialog () {
        return (
            <React.Fragment>
                {open && (
                    <PurchaseTransactionsDialog
                        open={open}
                        onClose={() => {
                            setOpen(false);
                        }}
                        usage={usage}
                        onPaymentSuccess={openSuccessDialog}
                    />
                )}
                {renderSuccessDialog()}
            </React.Fragment>
        );
    }

    function openDialog () {
        setOpen(true);
    }

    return {
        renderPurchaseTransactionsDialog,
        openDialog,
    };
}

export default usePurchaseTransactionsDialog;
